import { useEffect } from "react";

function setTag(selector, tag, attrs, valueAttr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute(valueAttr, value);
}

export const useSeo = (title, description, path) => {
  useEffect(() => {
    const origin = window.location.origin;
    const url = `${origin}${path}`;
    document.title = title;
    setTag('meta[name="description"]', "meta", { name: "description" }, "content", description);
    setTag('link[rel="canonical"]', "link", { rel: "canonical" }, "href", url);
    setTag('meta[property="og:url"]', "meta", { property: "og:url" }, "content", url);
    setTag('meta[property="og:title"]', "meta", { property: "og:title" }, "content", title);
    setTag('meta[property="og:description"]', "meta", { property: "og:description" }, "content", description);
    setTag('meta[property="og:image"]', "meta", { property: "og:image" }, "content", `${origin}/img/og-image.png`);
    setTag('meta[name="twitter:image"]', "meta", { name: "twitter:image" }, "content", `${origin}/img/og-image.png`);
    return () => { document.head.querySelector('link[rel="canonical"]')?.remove(); };
  }, [title, description, path]);
};
